/*
  BunMeowCreates header nav behavior: mobile menu toggle, click-outside to
  close. Ported from bunmeow-creates-web's Navbar.jsx - the sliding pill
  indicator that used to live here was dropped along with the pill nav
  itself; "active" is now shown via bold+underline, decided server-side in
  header.liquid via Shopify's link.active, so no JS is needed for it.
*/
document.addEventListener('DOMContentLoaded', function () {
  var navbar = document.querySelector('[data-bunmeow-navbar]');
  if (!navbar) return;

  var toggle = navbar.querySelector('[data-bunmeow-navbar-toggle]');
  var list = navbar.querySelector('[data-bunmeow-navbar-list]');
  if (!list) return;

  var isOpen = false;

  function setOpen(open) {
    isOpen = open;
    list.classList.toggle('bunmeow-navbar_list--open', open);
    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close navigation menu' : 'Open navigation menu');
    }
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      setOpen(!isOpen);
    });
  }

  function handleOutsideInteraction(event) {
    if (!isOpen) return;
    if (navbar.contains(event.target)) return;
    setOpen(false);
  }

  document.addEventListener('mousedown', handleOutsideInteraction);
  document.addEventListener('touchstart', handleOutsideInteraction);
});
